import { i18n } from "@lingui/core";
import { messages as en } from "./locales/en/messages";
import { messages as es } from "./locales/es/messages";

export type AppLocale = "en" | "es";

function detectLocale(): AppLocale {
  if (typeof window !== "undefined" && window.navigator?.language) {
    const base = window.navigator.language.slice(0, 2).toLowerCase();
    if (base === "es") return base;
  }
  return "en";
}

i18n.load({ en, es });
i18n.activate(detectLocale());

export { i18n };

export function activateLocale(locale: AppLocale): void {
  i18n.activate(locale);
}
